import React, { useEffect } from 'react'
import Dashboardmy from '../Dashboard-component/Dashboard';
import ShoppingCart from '../Shoppingcart/Shopping';
import './cart.css';
import { useSelector } from 'react-redux';
import {useNavigate} from 'react-router-dom';
function CartDash() {
    const navigate = useNavigate();
    const login = useSelector((state) => state.auth?.auth?.access_token);
    useEffect(() => {
        if (!login) {
            navigate('/login'); // or any page you want
        }
    }, [login, navigate]);
    return (
        <>
            <div className='cart-content'>

                <Dashboardmy />
                <div className='cart-container'>
                    <ShoppingCart />

                </div>
            </div>
        </>

    )
}

export default CartDash;
